import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { EventEmitter } from 'events';
import { RoundTripCommand } from "./commands/RoundTripCommand";
var CLOSE_EVENT = Symbol('close');
export var CommandBus = /*#__PURE__*/function () {
  function CommandBus(source) {
    _classCallCheck(this, CommandBus);
    this.source = source;
    _defineProperty(this, "emitter", new EventEmitter());
    _defineProperty(this, "payloadHandlerMap", new WeakMap());
  }
  _createClass(CommandBus, [{
    key: "execute",
    value: function execute(command) {
      var _this = this;
      var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var ack = arguments.length > 2 ? arguments[2] : undefined;
      if (!this.emitter.listenerCount(command.type)) {
        console.warn("No listeners registered for ".concat(command.type));
      }
      if (!ack && command instanceof RoundTripCommand) {
        return new Promise(function (resolve) {
          _this.emitter.emit(command.type, command, extra, resolve);
        });
      }
      this.emitter.emit(command.type, command, extra, ack);
      return undefined;
    }
  }, {
    key: "on",
    value: function on(commandType, handler) {
      var commandHandler = function commandHandler(command, extra, ack) {
        return handler(command.payload, extra, ack);
      };
      if (this.payloadHandlerMap.has(handler)) return;
      this.payloadHandlerMap.set(handler, commandHandler);
      this.onCmd(commandType, commandHandler);
    }
  }, {
    key: "off",
    value: function off(commandType, handler) {
      var commandHandler = this.payloadHandlerMap.get(handler);
      this.payloadHandlerMap.delete(handler);
      this.offCmd(commandType, commandHandler);
    }
  }, {
    key: "onCmd",
    value: function onCmd(commandType, handler) {
      this.emitter.on(commandType.type, handler);
    }
  }, {
    key: "offCmd",
    value: function offCmd(commandType, handler) {
      this.emitter.off(commandType.type, handler);
    }
  }, {
    key: "onClose",
    value: function onClose(fn) {
      this.emitter.once(CLOSE_EVENT, fn);
    }
  }, {
    key: "close",
    value: function close() {
      this.emitter.emit(CLOSE_EVENT);
    }
  }]);
  return CommandBus;
}();